var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"responsive-base-card"},[_c('div',{staticClass:"d-flex justify-end"},[_vm._t("additionalInfo")],2),_c('h1',{staticClass:"my-4 page-title-main"},[_vm._t("title"),_vm._t("actions")],2),[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }